// v1
// Path: frontend/src/components/SyncHub/shared/SyncRunnerView.jsx
import React from 'react';

export default function SyncRunnerView({
    selectedQBEntity,
    syncLimit,
    setSyncLimit,
    loadingSync,
    syncResult,
    handleExecuteLiveSync
}) {
    return (
        <div className="flex-1 overflow-y-auto bg-slate-900 p-4">
            <div className="max-w-3xl mx-auto space-y-6">
                <div className="bg-slate-850 border border-slate-750 rounded-xl p-6 text-center space-y-4">
                    <span className={`material-symbols-outlined text-4xl mb-2 ${loadingSync ? 'text-indigo-400 animate-spin' : 'text-slate-400'}`}>
                        {loadingSync ? 'sync' : 'cloud_upload'}
                    </span>
                    <h3 className="text-lg font-bold text-white">Execution Runner ({selectedQBEntity})</h3>
                    <p className="text-slate-400 text-sm">
                        Write up to <strong>{syncLimit}</strong> records directly to live target destination?
                    </p>
                    <div className="flex justify-center items-center gap-4 py-4">
                        <label className="text-slate-300 text-sm">Record Limit:</label>
                        <input
                            type="number"
                            min="1"
                            max="5000"
                            value={syncLimit}
                            onChange={e => setSyncLimit(Number(e.target.value))}
                            className="bg-slate-900 border border-slate-700 text-white rounded px-3 py-1.5 w-24 focus:outline-none focus:border-indigo-500"
                        />
                    </div>
                    <button
                        type="button"
                        onClick={() => handleExecuteLiveSync(false)}
                        disabled={loadingSync}
                        className="px-6 py-2.5 bg-indigo-600 hover:bg-indigo-500 text-white rounded-lg font-bold transition-colors flex justify-center items-center gap-2 shadow-lg disabled:opacity-50 mx-auto"
                    >
                        {loadingSync ? 'Executing...' : 'Execute Live Sync'}
                    </button>
                </div>

                {syncResult && (
                    <div className={`border rounded-xl p-6 ${syncResult.status === 'SUCCESS' ? 'bg-emerald-950/30 border-emerald-900/50' : syncResult.status === 'PARTIAL' ? 'bg-amber-950/30 border-amber-900/50' : 'bg-rose-950/30 border-rose-900/50'}`}>
                        <div className="flex items-start gap-4">
                            <span className={`material-symbols-outlined text-3xl ${syncResult.status === 'SUCCESS' ? 'text-emerald-400' : syncResult.status === 'PARTIAL' ? 'text-amber-400' : 'text-rose-400'}`}>
                                {syncResult.status === 'SUCCESS' ? 'check_circle' : (syncResult.status === 'PARTIAL' ? 'warning' : 'error')}
                            </span>
                            <div className="space-y-3 flex-1">
                                <div>
                                    <h4 className="font-bold text-white">Execution Status: {syncResult.status} ({syncResult.durationSeconds !== undefined ? `${syncResult.durationSeconds}s` : `${syncResult.durationMs || 0}ms`})</h4>
                                    <p className="mt-1 text-slate-300 text-sm">{syncResult.summary}</p>
                                </div>
                                <div className="grid grid-cols-3 gap-3">
                                    <div className="bg-slate-900/80 rounded p-2 text-center border border-slate-800">
                                        <div className="text-emerald-400 font-bold">+{syncResult.recordsInserted ?? syncResult.inserted ?? 0}</div>
                                        <div className="text-[10px] text-slate-400">Created</div>
                                    </div>
                                    <div className="bg-slate-900/80 rounded p-2 text-center border border-slate-800">
                                        <div className="text-blue-400 font-bold">{syncResult.recordsUpdated ?? syncResult.updated ?? 0}</div>
                                        <div className="text-[10px] text-slate-400">Updated</div>
                                    </div>
                                    <div className="bg-slate-900/80 rounded p-2 text-center border border-slate-800">
                                        <div className="text-rose-400 font-bold">{syncResult.recordsFailed ?? syncResult.failed ?? 0}</div>
                                        <div className="text-[10px] text-slate-400">Failed</div>
                                    </div>
                                </div>
                                {syncResult.errors && syncResult.errors.length > 0 && (
                                    <div className="mt-4 p-3 bg-rose-950/50 border border-rose-900/50 rounded-lg text-xs space-y-2">
                                        <h5 className="font-bold text-rose-300">Error Diagnostics ({syncResult.errors.length} failed):</h5>
                                        <ul className="list-disc pl-4 text-rose-200/80 space-y-1">
                                            {syncResult.errors.slice(0, 10).map((err, idx) => (
                                                <li key={idx} className="font-mono">{typeof err === 'object' ? JSON.stringify(err) : String(err)}</li>
                                            ))}
                                            {syncResult.errors.length > 10 && (
                                                <li className="italic">...and {syncResult.errors.length - 10} more.</li>
                                            )}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
